<template>
    <div class="pos-totals">
        <b-list-group>
            <b-list-group-item variant="primary">Subtotal: {{parseFloat(OrderTotal).toFixed(2) + " €"}}</b-list-group-item>
            <b-list-group-item variant="info" button id="list-descuento" @click=ParkAndCalcDisc()> Descuento: {{parseFloat(OrderDiscAmount).toFixed(2) + " €"}}</b-list-group-item>
            <b-list-group-item variant="info" button id="list-impuestos" title="Desglose Impuestos">Impuestos: {{parseFloat(OrderTotalVAT).toFixed(2) + " €"}}</b-list-group-item>            
            <b-popover :target="'list-impuestos'"
                   :placement="'lefttop'"
                   title="Desglose Impuestos"
                   :content="'Aquí se mostrará el desglose de impuestos'">
            </b-popover>
            <b-popover target="list-descuento" :placement="'lefttop'" title="Aplicar Dto. global">
                 <b-form>
                    <b-form-row>
                        <b-form-group>
                            <b-form-radio-group v-model="disctype" id="radios2" name="radioSubComponent">
                                <b-form-radio value="%">%</b-form-radio>
                                <b-form-radio value="€">€</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                        <b-col><b-form-input  v-model="discamount" type="text" :placeholder="disctype"/></b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-button @click=ParkAndCalcDisc()>Aplicar</b-button>  
                    </b-form-row>
                </b-form>
            </b-popover>
            <b-list-group-item v-if="this.$store.state.customer.combineShip == 1" variant="primary">
                <b-form-checkbox @change=SaveQuote() id="checkbox1"
                     v-model="CombineShipments"
                     value=1
                     unchecked-value=0>
                Fact. automática
                </b-form-checkbox>    
            </b-list-group-item>            
            <b-list-group-item v-if="this.$store.state.curDocType == 1 || this.$store.state.curDocType == 5" @click="GoPayment()" variant="success" button>
                PAGAR: {{parseFloat(OrderTotalIncVAT).toFixed(2) + " €"}}
            </b-list-group-item>
            <b-list-group-item v-if="this.$store.state.curDocType == 1 || this.$store.state.curDocType == 5" @click="SaveQuote()" variant="success" button>
                <b-spinner v-if="processing" small type="grow"></b-spinner>
                {{saveText}}
            </b-list-group-item>
            <b-list-group-item v-if="this.$store.state.curDocType == 0" @click="SaveQuote()" variant="success" button>
                <b-spinner v-if="processing" small type="grow"></b-spinner>               
                {{saveText}}: {{parseFloat(OrderTotalIncVAT).toFixed(2) + " €"}}
            </b-list-group-item>
            <b-list-group-item v-if="this.$store.state.curDocType == 0" @click="SavePrintQuote()" variant="success" button>IMPRIMIR</b-list-group-item>
        </b-list-group>            
    </div>
</template>

<script>

import mixin from '@/components/mixin.js'

export default {
    mixins:[mixin],
    name: 'PosTotals',
    data() {
        return {
            form: {
                CardId: ''                
            },
            alertvariant : "warning",             
            alerttxt: "",
            dismissCountDown : 0,
            disctype : "€",
            discamount : this.OrderDiscAmount,
            processing: false,
            saveText: "GUARDAR"            
        }
    },
    created: function () {
        this.discamount = this.OrderDiscAmount        
    }, 
    computed:{
        OrderTotal(){
            return this.$store.getters.OrderTotal
        },
        OrderTotalVAT(){
            return this.$store.getters.OrderTotalVAT
        },
        OrderTotalIncVAT(){
            return this.$store.getters.OrderTotalIncVAT
        },
        OrderDiscAmount(){
            return this.$store.state.globaldiscamount
        },
        CombineShipments: {
            get () {
                return this.$store.state.orderproperties.CombineShipments
            },
            set (value) {
                this.$store.commit('updateCombineShipments', value)
            }
        }
    }, 
    methods: {
        onSubmit(evt) { 
            var SalesOrder = {
                CustNo : this.$store.state.customer.id,
                SalesLines : this.$store.state.items
            }
            this.axios.post(this.ApiBaseUrl + 'Sales/CreateSalesOrder',
                        JSON.stringify(SalesOrder),
                        {headers: {"Content-Type": "application/json"}})            
            .then((response) => {        
                //this.options = response.data;
                var res = response;                
            })
            
        },
        countDownChanged (dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        onReset (evt) {
            evt.preventDefault();
            /* Reset our form values */
            this.form.PosId = '';
            this.form.Pwd = '';            
            /* Trick to reset/clear native browser form validation state */
            this.show = false;
            this.$nextTick(() => { this.show = true });
        },
        ParkAndCalcDisc(){
            this.parkSale().then((data) => {
                var req =  {
                    orderno: this.$store.state.curOrder,                    
                    discamount: parseFloat(this.discamount),
                    disctype: this.disctype,  
                    ordertype: this.$store.state.curDocType                  
                }
                this.CalcDisc(req).then((data) =>{
                    this.$store.dispatch("resetPOSRecover").then((data) =>{
                        this.RecoverSale(this.$store.state.curOrder)
                    })
                })
            })
        },        
        SaveQuote(){
            
            
            if (this.processing === true) {                
                return;
            }
            
            //Si el cliente tiene varias direcciones de envío, es obligatorio inidicarla
            if (this.$store.state.custShipToList.length > 0 && !this.$store.state.orderproperties.ShipToCode)
            {               
                return 0
            }

            this.processing = true
            this.saveText =  "Guardando..."          
            
            this.parkSale().then((response) => { 
               this.processing = false    
               this.saveText =  "GUARDAR"                
            })
            .catch(error => {
                    this.processing = false    
                    this.saveText =  "GUARDAR" 
                   
                    this.$store.commit('setModalMsg', error.response.data.message)
                    this.$store.commit('setModalVisible', true)                   
                    
            });
        },
        SavePrintQuote(){
            //Si el cliente tiene varias direcciones de envío, es obligatorio inidicarla
            if (this.$store.state.custShipToList.length > 0 && !this.$store.state.orderproperties.ShipToCode)
            {               
                return 0
            }

            if (this.processing === true) {                
                return;
            }
            
            this.parkSale().then((data) =>{
                    this.axios.post(this.ApiBaseUrl + 'PosFunctions/PrintQuote',
                        JSON.stringify(this.$store.state.curOrder),
                        {headers: {"Content-Type": "application/json"}})            
                    .then((response) => {                                
                        window.open(this.PrintDocsFolder + response.data.return_value);                                  
                    })
                })
        },
        GoPayment(){
            //Si el cliente tiene varias direcciones de envío ó el cliente tiene contacto autorizado, es obligatorio inidicarlo
            if (this.$store.state.custShipToList.length > 0 && !this.$store.state.orderproperties.ShipToCode ||
                this.$store.state.authContactList.length > 0 && !this.$store.state.orderproperties.AuthContact) {               
                return 0
            }

            if (Object.entries(this.$store.state.items).length === 0) {                
                return 0;
            }

            if (this.processing === true) {                
                return;
            }

            this.processing = true
            this.saveText =  "Procesando..."        
            
            this.parkSale().then((data) => {
                this.RecoverSale(this.$store.state.curOrder).then((data) =>{
                            this.processing = false   
                            this.$router.push('payment')
                })
            })
            .catch(error => {
                    this.processing = false    
                    this.saveText =  "GUARDAR"                    
                    this.$store.commit('setModalMsg', error.response.data.message)
                    this.$store.commit('setModalVisible', true)                   
                    
            });
        }        
    }
}
</script>